define('core/extensions/helpers/if_any',[],function () {
    'use strict';

    // if_any block helper
    // Usage: {{#if_any firstPost featuredPost}}...
    return function () {
        var len = arguments.length;
        var options = arguments[len - 1];
        for (var i = 0; i < len - 1; i++) {
            if (arguments[i])
                return options.fn(this);
        }
        return options.inverse(this);
    };
});

